(function () {
  var root = document.querySelector('[data-3rd-eye]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = '1';

  var Q = [
    {a:'AWARENESS', q:'Something makes you angry. What actually happens?', o:[
      ['I am angry. That is it. There is no gap.',0],
      ['I see it afterwards, usually hours later.',1],
      ['I catch it in the moment sometimes, and it changes what I do.',2],
      ['I can be angry and watch the anger at the same time.',3]]},
    {a:'EGO', q:'When you explain your own behaviour, what comes out?', o:[
      ['Causes. I was tired, provoked, that is just how I am.',0],
      ['Mostly causes. Sometimes a decision.',1],
      ['Mostly decisions.',2],
      ['I do not explain. I say what I chose.',3]]},
    {a:'EGO', q:'Someone tells you something true and unflattering about you. First movement?', o:[
      ['I explain why they are wrong.',0],
      ['I stay calm, then argue with them in my head for a week.',1],
      ['I feel the flinch, then ask whether it is true.',2],
      ['I ask whether it is true before I feel anything.',3]]},
    {a:'ATTACHMENT', q:'Think of what you would least like to lose. If it went, what goes with it?', o:[
      ['Me. There would be nothing left.',0],
      ['Most of me. I would be a long time rebuilding.',1],
      ['A great deal. I would grieve, but I would still be here.',2],
      ['I would grieve. I would not be reduced.',3]]},
    {a:'ATTACHMENT', q:'Detachment, to you, is…', o:[
      ['Not wanting things. I am nowhere near that.',0],
      ['Something I perform when I have been hurt.',1],
      ['Something I aim at and force, and it keeps slipping.',2],
      ['Love without dependency. It arrives on its own.',3]]},
    {a:'PRESENCE', q:'Where does your mind go when it is unoccupied?', o:[
      ['Replaying something old.',0],
      ['Simulating something that has not happened.',1],
      ['Both, and at least I notice.',2],
      ['Here, mostly. I come back fast when I leave.',3]]},
    {a:'PRESENCE', q:'The version of you from five years ago:', o:[
      ['I am ashamed of him. It still costs me.',0],
      ['I judge him, then tell myself not to.',1],
      ['Different conditions, different information. Mostly settled.',2],
      ['A different configuration entirely. Not mine to sentence.',3]]},
    {a:'ALIGNMENT', q:'When did you last do something you did not feel like doing, purely because it was right?', o:[
      ['I cannot think of one.',0],
      ['Somewhere in the last month.',1],
      ['This week.',2],
      ['Today. It is the ordinary shape of my day.',3]]},
    {a:'ALIGNMENT', q:'Have you chosen a side?', o:[
      ['I do not know what that means yet.',0],
      ['I deliberate. Every test feels like a fresh referendum.',1],
      ['I chose, but I reopen it under pressure.',2],
      ['Chosen. The work now is holding it.',3]]},
    {a:'AWARENESS', q:'Twenty minutes after leaving someone, do you know whether you are clearer or foggier?', o:[
      ['I have never thought about it.',0],
      ['I feel it, and I ignore it.',1],
      ['I notice, and sometimes act on it.',2],
      ['I read it deliberately. It decides who I spend time with.',3]]},
    {a:'ALIGNMENT', q:'You fail. How long until you are back?', o:[
      ['Months. I dwell, and I call it accountability.',0],
      ['Weeks.',1],
      ['Days.',2],
      ['Hours. Name it, own it, repair it, fly.',3]]},
    {a:'AWARENESS', q:'Is there a test you are currently refusing to sit?', o:[
      ['I do not think in those terms.',0],
      ['Probably. I could not name it.',1],
      ['Yes, and I can name it.',2],
      ['Yes. I named it, and I am sitting it now.',3]]}
  ];

  var AX = ['AWARENESS','ATTACHMENT','PRESENCE','EGO','ALIGNMENT'];

  var WEAK = {
    AWARENESS: 'You can review yourself, but you cannot yet watch yourself live. Hindsight tells you what happened to you; live awareness changes what happens next. The manual trains this in Section 2, naming without joining. It is the cheapest skill here and the one everything else runs on.',
    ATTACHMENT: 'Something you love is currently load-bearing, which means it can take you with it. Zuhd is not owning less or feeling less. It is love without dependency, and it cannot be forced. Section 4 covers how to test an attachment without giving it up, and why forcing detachment fails under load.',
    PRESENCE: 'You are spending real time on frequencies where the controls are not connected: replay behind you, simulation ahead. Neither is a place you can act from. Section 4 covers time as dimension, why comparing yourself to your past self is a category error, and how to shorten the return.',
    EGO: 'Your reflex is to explain rather than consider. That is the third answer, the one that is not on the paper. Ego does not make you fail the test; it makes you refuse to sit it, and a test unanswered gets returned in worse conditions. Section 3 is written for exactly this.',
    ALIGNMENT: 'You know a great deal and act on less of it than you should. Awareness without a decision becomes paralysis: you see everything and attempt nothing. Section 6 is about making the choice once, deliberately, so the daily work becomes holding instead of deciding.'
  };

  var LEVEL = {
    label: 'Nothing reads as weak',
    text: 'No instrument came back low, which either means you are flying well or means you answered the way you would like to be rather than the way you are. Both are worth knowing. Take it again in a month without remembering what you put last time. The second reading is always the honest one.'
  };

  var TIERS = [
    {max:12, name:'Ground Level', line:'The questions are still closed.',
     body:'<p>You are living as though the questions are settled, not because you answered them, but because they were never opened. This is not stupidity. Some of the most intelligent people alive are here. It is the absence of one particular pause: the pause where the soul gets a turn to speak.</p><p>The good news is unglamorous. Everyone at every altitude started here, and the distance from here to the next one is a single deliberate question asked before the day starts.</p>',
     pitch:'This manual is written for the pause you have not taken yet. It does not ask you to believe anything before you test it. It hands you the seat check, the three instruments, and the daily preflight, and lets you find out for yourself who has been flying.'},
    {max:24, name:'Climbing', line:'You know something is off. You cannot close the question again.',
     body:'<p>This is the most uncomfortable altitude, and it is the one almost everybody reading this is at. You have lost the certainty and not yet gained the alignment. That gap is exposed, and it is why so many people deliberately descend. The ground is warmer.</p><p>Everyone here believes they are alone here. They are not. What separates climbing from cruising is not more insight. It is a decision, made once, that stops every test being a referendum on your whole character.</p>',
     pitch:'You already have the awareness. What you are missing is the structure to act on it, and a decision you keep postponing. This manual is that structure: tests and what they measure, ego as the answer that is not on the paper, and the choice underneath all the others.'},
    {max:36, name:'Cruising', line:'Not finished. Nobody finishes.',
     body:'<p>You have stopped needing the question answered before you can act. The fundamental choice is made, and the daily work is holding it rather than reopening it, which is a lighter, harder, far less dramatic discipline than deciding.</p><p>The mark of this altitude is not serenity. It is return time. You fall like everyone else. You come back in hours instead of years.</p>',
     pitch:'You will recognise most of this, which is the point. Recognition is how you find out your framework holds outside your own head. What is here that is probably not yet in yours: the escalation logic of tests, why forced detachment fails, and the logbook that keeps return time short.'}
  ];

  var stage = root.querySelector('[data-stage]'), res = root.querySelector('[data-res]');
  var elProg = root.querySelector('[data-prog]'), elQn = root.querySelector('[data-qn]'),
      elQ = root.querySelector('[data-q]'), elOpts = root.querySelector('[data-opts]'),
      elBack = root.querySelector('[data-back]');
  var i = 0, ans = new Array(Q.length).fill(null);

  Q.forEach(function(){ elProg.appendChild(document.createElement('i')); });

  /* Only scroll when the target is not already comfortably on screen. Answering
     a question must never move the page: the next question renders in the same
     place the last one occupied. */
  function nudge(el){
    if (!el) return;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.top < 0 || r.top > vh - 140) {
      window.scrollTo({ top: window.pageYOffset + r.top - 90, behavior: 'smooth' });
    }
  }

  function paint(){
    var q = Q[i];
    elQn.textContent = 'Question ' + (i+1) + ' of ' + Q.length;
    elQ.textContent = q.q;
    elOpts.innerHTML = '';
    q.o.forEach(function(o, k){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'te-opt' + (ans[i] === k ? ' sel' : '');
      b.textContent = o[0];
      b.addEventListener('click', function(){ ans[i] = k; advance(); });
      elOpts.appendChild(b);
    });
    Array.prototype.forEach.call(elProg.children, function(n, k){ n.classList.toggle('on', k <= i); });
    elBack.hidden = i === 0;
  }

  function advance(){
    if (i < Q.length - 1){ i++; paint(); }
    else finish();
  }

  elBack.addEventListener('click', function(){ if (i > 0){ i--; paint(); } });

  function finish(){
    var per = {}, cnt = {}, total = 0;
    AX.forEach(function(a){ per[a] = 0; cnt[a] = 0; });
    Q.forEach(function(q, k){ var v = q.o[ans[k]][1]; total += v; per[q.a] += v; cnt[q.a] += 3; });

    var tier = TIERS.filter(function(t){ return total <= t.max; })[0];
    root.querySelector('[data-altname]').textContent = tier.name;
    root.querySelector('[data-scoreline]').textContent = tier.line + '  ·  ' + total + ' of 36';
    root.querySelector('[data-altbody]').innerHTML = tier.body;
    root.querySelector('[data-pitch]').textContent = tier.pitch;

    var weakest = AX[0], wpct = 2;
    AX.forEach(function(a){ var p = per[a] / cnt[a]; if (p < wpct){ wpct = p; weakest = a; } });
    var noWeak = wpct >= 0.84;

    root.querySelector('[data-weaklabel]').textContent = noWeak ? LEVEL.label : 'Your weakest instrument';
    root.querySelector('[data-weak]').textContent = noWeak ? LEVEL.text : WEAK[weakest];

    var bars = root.querySelector('[data-bars]');
    bars.innerHTML = '';
    AX.forEach(function(a){
      var pct = Math.round(per[a] / cnt[a] * 100);
      var row = document.createElement('div');
      row.className = 'te-bar' + (!noWeak && a === weakest ? ' weak' : '');
      row.innerHTML = '<b>' + a + '</b><div class="te-track"><div class="te-fill"></div></div><span>' + pct + '%</span>';
      bars.appendChild(row);
      setTimeout(function(){ row.querySelector('.te-fill').style.width = pct + '%'; }, 60);
    });

    stage.hidden = true; res.hidden = false;
    nudge(res);
  }

  root.querySelector('[data-again]').addEventListener('click', function(){
    i = 0; ans = new Array(Q.length).fill(null);
    res.hidden = true; stage.hidden = false; paint();
    nudge(stage);
  });

  paint();
})();
